import { action, observable } from 'mobx';
import {
  checkSddAvailabilityByCartForSidebar,
  checkSddAvailabilityByProducts,
  extractSddDataFromProductAvailabilityData,
} from './sddUtils';
import { mapCartItemsToBopisAndSddParamItems } from '../../utils';
import { SiteSettings } from 'src/scripts/utils/environment';
import { setStoreLocatorSidebarIsLoadingState } from '../StoreLocator/storeLocatorSidebarState';
import { ISddState } from './sddTypes';
import { IVariant } from '../../types/PDP';

export const sddState = observable<ISddState>({
  enabled: SiteSettings.sddEnabled,
  pdpSddData: null,
  pdpSddDataError: null,
  cartSddData: null,
  cartSddDataError: null,
  isFetchingData: false,
  async fetchSddDataPdp(selectedVariant: IVariant, isGWP = false) {
    const { sku, requiresShipping } = selectedVariant;
    const products = [
      {
        sku: sku,
        quantity: 1,
        isGWP,
        requires_shipping: requiresShipping,
      },
    ];
    setStoreLocatorSidebarIsLoadingState(true);
    const response = await checkSddAvailabilityByProducts(products);
    setStoreLocatorSidebarIsLoadingState(false);
    if ('detail' in response) {
      console.log({ error: response.detail });
      if (response.detail.toLowerCase() !== 'location is unknown') this.pdpSddDataError = response;
      return { success: false };
    } else {
      if (this.pdpSddDataError) this.pdpSddDataError = null;
      const sddData = extractSddDataFromProductAvailabilityData(response);
      this.pdpSddData = sddData;
      return {
        success: true,
      };
    }
  },
  async fetchSddDataCart(cartData) {
    if (cartData.regularItems.length === 0) return { success: false };
    const mappedItems = mapCartItemsToBopisAndSddParamItems(cartData);
    setStoreLocatorSidebarIsLoadingState(true);
    const response = await checkSddAvailabilityByCartForSidebar(mappedItems);
    setStoreLocatorSidebarIsLoadingState(false);
    if ('detail' in response) {
      console.log({ error: response.detail });
      this.cartSddDataError = response;
      return { success: false };
    } else {
      if (this.cartSddDataError) this.cartSddDataError = null;
      this.cartSddData = response;
      return { success: true };
    }
  },
});

export const setIsFetchingData = action((newValue: boolean) => {
  sddState.isFetchingData = newValue;
});
